export interface Citation {
  raw: string;
  path: string;
  sha: string;
}

// Matches file:path@sha or repo:path@sha. Path allows [a-zA-Z0-9/_.-], SHA is 7-40 hex chars.
const CITATION_PATTERN = /(?:file|repo):[a-zA-Z0-9/_.-]+@[a-f0-9]{7,40}/g;

// Deduplicates by raw string so repeated references produce a single entry.
export function extractCitations(text: string): Citation[] {
  const matches = text.match(CITATION_PATTERN);
  if (!matches) {
    return [];
  }

  const seen = new Set<string>();
  const results: Citation[] = [];

  for (const raw of matches) {
    if (seen.has(raw)) {
      continue;
    }
    seen.add(raw);
    const colonIndex = raw.indexOf(":");
    const atIndex = raw.lastIndexOf("@");
    results.push({
      raw,
      path: raw.slice(colonIndex + 1, atIndex),
      sha: raw.slice(atIndex + 1),
    });
  }

  return results;
}
